import {
    GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS,
    GETCUSTOMERIDANDNAMELISTADMIN_FAILED,
    RESET_GETCUSTOMERIDANDNAMELISTADMIN,
    LOADING_GETCUSTOMERIDANDNAMELISTADMIN,
    NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCUSTOMERIDANDNAMELISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETCUSTOMERIDANDNAMELISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETCUSTOMERIDANDNAMELISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};